import React, { useEffect, useState } from 'react';
import { tenantApi } from '../../api/tenantApi';
import { Panel, Loader, EmptyState, useToast, errText } from '../ui';

export default function AllDatabases() {
  const toast = useToast();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const [res, setRes] = useState(null);
  const [registered, setRegistered] = useState(null);

  const load = async (p) => {
    setRes(null);
    try {
      const data = await tenantApi.getAllDatabases(p, pageSize);
      setRes(data);
    } catch (err) {
      toast.error(errText(err));
      setRes({ data: [] });
    }
    try {
      const tenants = await tenantApi.getAllTenants();
      setRegistered(new Set((tenants.data || []).map((t) => t.databaseName)));
    } catch {
      setRegistered(new Set());
    }
  };

  useEffect(() => { load(page); }, [page]); // eslint-disable-line

  const rows = res?.data || [];

  const nameOf = (r) => r.databaseName || r.name || r.dbName || JSON.stringify(r);

  return (
    <>
      <h1 className="page-title">all_databases</h1>
      <p className="page-sub">
        GET /v1/admin/tenants/database/all — every database on the server, not just registered tenants.
        Unregistered entries usually mean Step 1 ran but Step 3 never did (or a registration was removed
        without dropping the DB).
      </p>

      <Panel title="// SERVER_DATABASES">
        {res === null && <Loader label="fetching database list" />}
        {res !== null && rows.length === 0 && <EmptyState>No databases returned.</EmptyState>}

        {res !== null && rows.length > 0 && (
          <>
            <table className="term-table">
              <thead>
                <tr>
                  <th>database</th>
                  <th>status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => {
                  const name = nameOf(r);
                  const isReg = registered ? registered.has(name) : null;
                  return (
                    <tr key={name + i}>
                      <td>{name}</td>
                      <td>
                        {isReg === null && <span className="badge badge--muted">checking...</span>}
                        {isReg === true && <span className="badge badge--ok">REGISTERED</span>}
                        {isReg === false && <span className="badge badge--warn">NOT REGISTERED</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="pager">
              <button className="term-btn term-btn--sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>← prev</button>
              <span>page {res.page} / {res.totalPages} · {res.totalRecords} records</span>
              <button className="term-btn term-btn--sm" disabled={page >= (res.totalPages || 1)} onClick={() => setPage((p) => p + 1)}>next →</button>
            </div>
          </>
        )}
      </Panel>
    </>
  );
}
